import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allBuildings: [],
  buildingName: "",
  buildingData: null,
  currentClean: null,
  currentCleanData: null,
  drops: [],
  selectDropModal: false,
  dateModal: false,
  editDate: null,
  dropDate: null,
  currentDrop: null,
  cleans: null,
  building: null,
  cleanNames: null,
  isWeatherOK: true,
  fetchNewData: false,
  weatherForm: false,
  equipmentForm: false,
  ppeForm: false,
  latestWeatherInfo: null,
  selectedBuilding: "",
  refreshBuildingVersion: 0,
  error: null, // PHASE 1 FIX: Added error state for proper error handling
};

const buildingSlice = createSlice({
  name: "buildingNames",
  initialState,
  reducers: {
    buildingsList(state, action) {
      state.allBuildings = action.payload.buildings;
    },
    setBuilding(state, action) {
      state.buildingName = action.payload.name;
      state.buildingData = action.payload.data;
      state.currentClean = action.payload.currentClean;
      state.currentCleanData = action.payload.currentCleanData;
      state.drops = action.payload.drops;
    },
    setSelectDropModal(state, action) {
      state.selectDropModal = !state.selectDropModal;
    },
    setDateModal(state, action) {
      state.dateModal = !state.dateModal;
    },
    setEditDate(state, action) {
      state.editDate = action.payload.editDate;
    },
    setDropDate(state, action) {
      state.dropDate = action.payload.dropDate;
    },
    setCurrentDrop(state, action) {
      state.currentDrop = action.payload.drop;
    },
    setCurrentClean(state, action) {
      state.currentClean = action.payload.clean;
    },
    setCleanNames(state, action) {
      state.cleanNames = action.payload.names;
    },
    setIsWeatherOK(state, action) {
      state.isWeatherOK = action.payload.isOK;
    },
    setFetchNewData(state, action) {
      state.fetchNewData = action.payload.fetchData;
    },
    setDrops(state, action) {
      state.drops = action.payload.drops;
    },
    setWeatherForm(state, action) {
      const weatherForm =
        action?.payload && Object.prototype.hasOwnProperty.call(action.payload, "weatherForm")
          ? action.payload.weatherForm
          : action.payload;
      state.buildingData = { ...state.buildingData, weatherForm };
    },
    setEquipmentForm(state, action) {
      const equipmentForm =
        action?.payload && Object.prototype.hasOwnProperty.call(action.payload, "equipmentForm")
          ? action.payload.equipmentForm
          : action.payload;
      state.buildingData = { ...state.buildingData, equipmentForm };
    },
    setPpeForm(state, action) {
      const ppeForm =
        action?.payload && Object.prototype.hasOwnProperty.call(action.payload, "ppeForm")
          ? action.payload.ppeForm
          : action.payload;
      state.buildingData = { ...state.buildingData, ppeForm };
    },
    setLatestWeatherInfo(state, action) {
      state.latestWeatherInfo = action.payload.latestWeather;
    },
    setLastDropCleanName(state, action) {
      state.buildingData = { ...state.buildingData, ...action.payload };
    },
    setSelectedBuilding(state, action) {
      state.selectedBuilding = action.payload;
    },
    setCurrentCleanData(state, action) {
      state.currentCleanData = action.payload.currentData;
    },
    setLiveStreaming(state, action) {
      state.buildingData = { ...state.buildingData, isLiveStreaming: action.payload }
    },
    setRefreshBuildingVersion(state, action) {
      state.refreshBuildingVersion = state.refreshBuildingVersion + 1
    },
    setError(state, action) {
      // PHASE 1 FIX: Added error action for centralized error state management
      state.error = action.payload.error;
    }
  },
});

export const buildingListActions = buildingSlice.actions;

export default buildingSlice;
